import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { Dialog, DialogBody, DialogFooter } from '@blueprintjs/core';
import { css } from '@emotion/react';
import { Field, Formik } from 'formik';
import { useRef } from 'react';
import { DataExportOptions } from '../../data/SpectraManager';
import { useChartData } from '../context/ChartContext';
import ActionButtons from '../elements/ActionButtons';
import Label from '../elements/Label';
import FormikCheckBox from '../elements/formik/FormikCheckBox';
import FormikInput from '../elements/formik/FormikInput';
import useExport from '../hooks/useExport';
const styles = css `
  display: flex;
  flex-direction: column;

  label {
    margin-right: 20px;
    display: inline-block;
  }

  input[type='radio'] {
    margin-right: 5px;
  }
`;
const INITIAL_VALUE = {
    name: '',
    compressed: false,
    pretty: false,
    include: {
        dataType: DataExportOptions.ROW_DATA,
        view: false,
        settings: false,
    },
};
export const labelStyle = {
    label: {
        flex: 4,
        fontSize: '12px',
        color: '#232323',
    },
    wrapper: {
        flex: 8,
        display: 'flex',
        justifyContent: 'flex-start',
    },
    container: { padding: '5px 0' },
};
function SaveAsModal(props) {
    const { onCloseDialog, isOpen } = props;
    const refForm = useRef();
    const { source, data } = useChartData();
    const { saveHandler } = useExport();
    const fileName = data[0]?.info?.name;
    function submitHandler(values) {
        saveHandler(values);
        onCloseDialog?.();
    }
    if (!isOpen)
        return;
    return (_jsxs(Dialog, { isOpen: true, title: "Save as ... ", onClose: onCloseDialog, style: { width: 500 }, children: [_jsx(DialogBody, { css: css `
          background-color: white;
        `, children: _jsx(Formik, { innerRef: refForm, initialValues: { ...INITIAL_VALUE, name: fileName }, onSubmit: submitHandler, children: _jsxs(_Fragment, { children: [_jsx(Label, { style: labelStyle, title: "Name", children: _jsx(FormikInput, { name: "name", className: "name", style: {
                                        inputWrapper: { width: '100%' },
                                        input: { padding: '5px', textAlign: 'left' },
                                    } }) }), _jsx(Label, { style: labelStyle, title: "Compressed", children: _jsx(FormikCheckBox, { name: "compressed" }) }), _jsx(Label, { style: labelStyle, title: "Pretty format", children: _jsx(FormikCheckBox, { name: "pretty" }) }), _jsx(Label, { style: labelStyle, title: "Include view", children: _jsx(FormikCheckBox, { name: "include.view" }) }), _jsx(Label, { style: labelStyle, title: "Include settings", children: _jsx(FormikCheckBox, { name: "include.settings" }) }), _jsx(Label, { style: labelStyle, title: "Include data", children: _jsx("div", { css: styles, children: _jsxs("div", { children: [_jsxs("label", { children: [_jsx(Field, { type: "radio", name: "include.dataType", value: DataExportOptions.ROW_DATA }), "Raw data"] }), _jsxs("label", { style: {
                                                    color: source ? 'black' : 'lightgray',
                                                }, children: [_jsx(Field, { type: "radio", name: "include.dataType", value: DataExportOptions.DATA_SOURCE, disabled: !source }), "Data source"] }), _jsxs("label", { children: [_jsx(Field, { type: "radio", name: "include.dataType", value: DataExportOptions.NO_DATA }), "No data"] })] }) }) })] }) }) }), _jsx(DialogFooter, { children: _jsx(ActionButtons, { style: { flexDirection: 'row-reverse', margin: 0 }, onDone: () => refForm.current.submitForm(), doneLabel: "Save", onCancel: () => onCloseDialog?.() }) })] }));
}
export default SaveAsModal;
